export default {"src":"/_next/static/media/lastDay.f37c7c58.svg","height":18,"width":102,"blurWidth":0,"blurHeight":0};